import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'

class Sticker extends React.PureComponent {
  render() {
    return (
      <span
        style={_.extend(
          {
            color: '#' + this.props.foreground,
            backgroundColor: '#' + this.props.background,
            whiteSpace: 'nowrap'
          },
          this.props.noBorder
            ? {}
            : {
                border: '1px solid black',
              },
          this.props.circular
            ? {
                borderRadius: '50%',
                display: 'inline-block',
                textAlign: 'center',
                lineHeight: '24px',
                width: '26px'
              }
            : {
                lineHeight: '28px',
                padding: '3px 6px'
              }
        )}
      >
        {this.props.text}
      </span>
    )
  }
}

Sticker.propTypes = {
  foreground: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  circular: PropTypes.bool,
  noBorder: PropTypes.bool
}

export default Sticker



// WEBPACK FOOTER //
// ./src/components/elements/Sticker.js